var React = require('react');

function Map (props) {
    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M23.551 23.796a1.006 1.006 0 0 1-.945.083l-6.63-2.836-7.624 2.854c-.011.004-.021.002-.031.006a.996.996 0 0 1-.321.058c-.033 0-.062-.016-.094-.02a1.013 1.013 0 0 1-.299-.061l-.001-.001-7-2.994A.997.997 0 0 1 0 19.968V1.005A.997.997 0 0 1 1.316.058l3 .998a.998.998 0 1 1-.632 1.893L2 2.389V19.31l5 2.139v-3.477a.999.999 0 0 1 1-.998c.553 0 1 .447 1 .998v3.55l6-2.246v-1.304a.999.999 0 0 1 1-.998c.553 0 1 .447 1 .998v1.338l5 2.138V4.718l-2.316-.77a.998.998 0 1 1 .632-1.894l3 .998a.998.998 0 0 1 .684.947v18.963a1 1 0 0 1-.449.834zM12.64 17.741a1.002 1.002 0 0 1-1.28 0C11.101 17.525 5 12.393 5 6.843 5 3.074 8.141.007 12 .007s7 3.067 7 6.836c0 5.55-6.101 10.682-6.36 10.898zM12 2.003c-2.757 0-5 2.171-5 4.84 0 3.662 3.522 7.384 5 8.785 1.477-1.401 5-5.123 5-8.785 0-2.669-2.243-4.84-5-4.84zm-2 4.99a2 2 0 0 1 4 0 2 2 0 0 1-4 0z","key":1})]);
}

Map.displayName = "Map";

Map.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 24 23.97"};

module.exports = Map;

Map.default = Map;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/map.svg
// module id = 1277
// module chunks = 0